// extracted by mini-css-extract-plugin
export default {"root":"CardsBox_root__D9p+F","inView":"CardsBox_inView__6ysYn","movein":"CardsBox_movein__HilvE"};